export default {
  Print(elementName) {
    console.log('Inside Print of Print');
    const name = '_blank';
    const specs = ['fullscreen=no', 'titlebar=yes', 'scrollbars=yes'];
    const replace = true;
    const styles = [
      '/css/print.css',
      '/css/vuetify.min.css',
      '/css/bootstrap.min.css',
      // "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
      // "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css"
    ];

    // elementName="appointment-details";
    const element = document.getElementById(elementName);
    const url = '';
    const win = window.open(url, name, specs, replace);
    win.document.open();
    win.document.write(`
                  <html>
                    <head>
                      <title>${document.title}</title>
                      <script type="text/javascript">
                        function printMe(){
                          const elems = document.body.getElementsByTagName('*');
                          for (let i = 0; i < elems.length; i += 1) {
                            elems[i].style.fontFamily = 'Courier';
                            elems[i].style.fontWeight = 'bolder';
                          }
                          setTimeout(function(){
                            window.print();
                          },1000);
                        }
                        function closeMe(){
                          setTimeout(function(){
                            self.close();
                          },250);
                        }
                      </script>
                    </head>
                    <body onload="printMe()" onafterprint="closeMe()">
                      ${element.innerHTML}
                    </body>
                  </html>
                `);

    styles.forEach((style) => {
      const link = win.document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.setAttribute('href', style);
      win.document.getElementsByTagName('head')[0].appendChild(link);
    });

    win.document.close();
    if (!win || win.closed || typeof win.closed === 'undefined') {
      // TODO: handle popub blockers
      // alert('POPUP BLOCKER IS ON');
    }

    win.focus();
    // Moved Print to pop-up page to allow printing to work correctly in IE//
  },
};
